import {
  ENABLED_PATIENT_LOCALES,
  PREFERED_LANGUAGE,
  TLabel,
  TNavigationLocales,
  TPatientLocale,
} from 'src/types/locales'

const getFirstTranslation = (message: Partial<Record<TPatientLocale, string>>): string => {
  for (const lang of ENABLED_PATIENT_LOCALES) {
    const messageInLanguage = message[lang]
    if (messageInLanguage && messageInLanguage.length > 0) {
      return messageInLanguage
    }
  }
  return ''
}

const getMessageTranslatedForUserLocale = ({
  message,
  currentLocale,
}: {
  message?: Partial<Record<TPatientLocale, string>>
  currentLocale: TNavigationLocales
}): string => {
  if (!message) return ''
  const messageTranslatedForUserLocale = message[currentLocale]
  return messageTranslatedForUserLocale || getFirstTranslation(message)
}

// This should be removed when all label will be translated in backoffice
const getTranslatedLabel = (locale: TNavigationLocales, label?: TLabel) => {
  // const isNotifyOnMissingLabelActivated = process.env.isCurecallMessengerActivated === 'true'

  const labelToShow = label?.[locale]
  const labelFallback = label?.[PREFERED_LANGUAGE]
  // This is disabled because it cause too much errors on sentry :
  // if (!labelToShow && isNotifyOnMissingLabelActivated) {
  //   Sentry.captureMessage(`Label not found for locale ${locale} : ${JSON.stringify(label)}`)
  // }
  return labelToShow || labelFallback || ''
}

export { getMessageTranslatedForUserLocale, getTranslatedLabel }
